import { useEffect, useRef, useState } from 'react';
import { styled, keyframes, css } from 'styled-components';

const bounce = keyframes`
  0% {
    top: 0;
  }
  50% {
    top: -100px;
  }
  // 100% {
  //   top: 0px;
  // }
  to {
    top: 0px;
  } 
`;

const BounceItem = styled.span<{ $delay: number, $bounce: string }>`
  position: relative;
  display: inline-block;
  font-size: 80px;
  color: #FFF;
  z-index: 10;
  
  ${(props) => props.$bounce === "true" && css`
    animation: ${bounce} 1s ease;
    animation-delay: .${props.$delay}s;
  `}
`;

const BounceText = ({
  values,
}) => {
  const [isBounce, setIsBounce] = useState<boolean>(false);
  const bounceRef = useRef<HTMLDivElement[]>([]);

  const options:IntersectionObserverInit = {
    root: null,
    threshold: 0
  }
  const callback:IntersectionObserverCallback = (entries:IntersectionObserverEntry[],observer) => {
    // console.log(entries);
    entries.forEach((entry) => {
      const {
        isIntersecting, 
        boundingClientRect,
        target
      } = entry;
      // pageYOffset 문서가 수직으로 얼마나 스크롤 됐는지 픽셀 단위로 반환한다.
      // const scrollTop = document.getElementById("main").scrollTop;

      // 이벤트가 발생된 target의 height
      // const {height} = boundingClientRect;

      // 관찰 요소와 교차될때마다 index를 계산하여 viewIndex의 값을 바꿔준다.
      if(isIntersecting) {
        // const index = Math.round(scrollTop / height);
        setIsBounce(true);
      } else {
        setIsBounce(false);
      }
    });
  };
  
  const io = new IntersectionObserver(callback,options);

  useEffect(() => {
    const el = document.getElementById("bounce-box");
    io.observe(el);

    return () => {
      io.unobserve(el);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <>
      {values.split("").map((value, index) => {
        return (
          <div
            key={index}
            ref={(r) => { 
              if(r && bounceRef.current) return bounceRef.current[index] = r; 
            }}
          >
            <BounceItem $delay={index + 1} $bounce={isBounce.toString()}>
              {value}
            </BounceItem>
          </div>
        )}
      )}
    </>
  );
};

export default BounceText;